// Lib
import React from 'react';
import { Button as RomaButton, UtilityButton } from '@milanote/roma';
import { EditorToolbar } from '@milanote/roma/application';
import { Crop01Icon, Reflect01Icon, RotateCcw01Icon } from '@milanote/roma-icons';

// Components
import CancelDiscardButton from './CancelDiscardButton';

// Hooks
import { useTranslator } from '../../../../../components/i18n/useTranslator';

type ImageModalV2EditorToolbarProps = {
    cropActive: boolean;
    hasChanges: boolean;
    disabled: boolean;
    onCropClick: () => void;
    onRotateClick: () => void;
    onFlipHorizontalClick: () => void;
    onFlipVerticalClick: () => void;
    onCancelClick: () => void;
    onSaveClick: () => void;
};

const ImageModalV2EditorToolbar: React.FC<ImageModalV2EditorToolbarProps> = ({
    cropActive,
    hasChanges,
    disabled,
    onCropClick,
    onRotateClick,
    onFlipHorizontalClick,
    onFlipVerticalClick,
    onCancelClick,
    onSaveClick,
}) => {
    const translate = useTranslator('popup', 'imageModal.editor');

    return (
        <EditorToolbar.Shell>
            <EditorToolbar.List>
                <UtilityButton
                    isSelected={cropActive}
                    onPress={onCropClick}
                    isDisabled={disabled}
                    tooltip={{ title: translate('crop') }}
                >
                    <Crop01Icon />
                </UtilityButton>

                <UtilityButton
                    onPress={onRotateClick}
                    isDisabled={disabled}
                    tooltip={{ title: translate('rotateLeft') }}
                >
                    <RotateCcw01Icon />
                </UtilityButton>

                <UtilityButton
                    onPress={onFlipHorizontalClick}
                    isDisabled={disabled}
                    tooltip={{ title: translate('flipHorizontal') }}
                >
                    {/* Roma only ships the vertical reflect glyph; rotate it for the horizontal flip. */}
                    <Reflect01Icon className="rotate-90" />
                </UtilityButton>

                <UtilityButton
                    onPress={onFlipVerticalClick}
                    isDisabled={disabled}
                    tooltip={{ title: translate('flipVertical') }}
                >
                    <Reflect01Icon />
                </UtilityButton>

                <EditorToolbar.Divider type="spacer" />

                <div className="flex shrink-0 items-center gap-sm">
                    <CancelDiscardButton showDiscard={hasChanges} onClick={onCancelClick} />

                    <RomaButton onClick={onSaveClick} isDisabled={disabled}>
                        {translate('save')}
                    </RomaButton>
                </div>
            </EditorToolbar.List>
        </EditorToolbar.Shell>
    );
};

export default ImageModalV2EditorToolbar;
